import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import { SiteProvider } from "./lib/SiteContext";
import "./App.css";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#1C1917",
            border: "1px solid #D6D3D1",
            fontFamily: "Work Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
